export default __webpack_public_path__ + "static/media/dropverse_carousel_4.png.webp";